import React from "react";
import moment from "moment";
import { styled } from "@mui/material/styles";
import { Box, Grid, Typography } from "@mui/material";
import { formatPrice } from "@/utils/formatPrice";
import Modal from "@/components/modal";

const CarDetails = styled(Box)`
  overflow-y: auto;
  height: 300px;
`;

function CarRow({ name, value }) {
  return (
    <Grid container mb={1}>
      <Grid item xs={12} sm={2}>
        {name}
      </Grid>

      <Grid item xs={12} sm={10}>
        {value}
      </Grid>
    </Grid>
  );
}

const EditCarModal = ({ open, handleClose, selectedCar }) => {
  return (
    <Modal open={open} onClose={handleClose}>
      <Typography
        variant="h6"
        sx={{
          mb: 2,
        }}
      >
        {selectedCar.car_id}
      </Typography>
      <CarDetails>
        <CarRow name="Car Id" value={selectedCar.car_id} />
        <CarRow name="Price" value={formatPrice(selectedCar.price)} />
        <CarRow name="State" value={selectedCar.state} />
        <CarRow
          name="From Date"
          value={moment(selectedCar.fromDate).format("MMMM Do YYYY")}
        />
        <CarRow
          name="To Date"
          value={moment(selectedCar.toDate).format("MMMM Do YYYY")}
        />
      </CarDetails>
    </Modal>
  );
};

export default EditCarModal;
